<template>
  <a-modal
    :visible="showModal"
    @cancel="closeModal"
    :title="title"
    :footer="false"
    :destroyOnClose="true"
    :maskClosable="false"
    class="calendar-event-create-or-edit-modal-component"
  >

    <a-form-model-item label="In welke agenda wilt u de afspraak plaatsen?" :colon="false" v-if="canChooseCalendar">
      <a-radio-group class="full-width calendar-event-type" button-style="solid" v-model="calendarType">
        <a-radio-button value="dossierdata" class="half-width dossier-data">
          DossierData
        </a-radio-button>
        <a-radio-button value="onlineafspraken" class="half-width online-afspraken">
          OnlineAfspraken
        </a-radio-button>
      </a-radio-group>
    </a-form-model-item>

    <create-or-edit-calendar-event-component
      v-if="isCreatingOrEditingCalendarEvent"
      :event="calendarEvent"
      :customer-id="customerId"
      :attachable-key="attachableKey"
      :attachable-type="attachableType"
      @close="closeModal"
      @updated="onUpdated"
    ></create-or-edit-calendar-event-component>

    <create-or-edit-appointment-component
      v-if="isCreatingOrEditingAppointment"
      :appointment="appointment"
      :customer-id="getCustomerId"
      @close="closeModal"
      @updated="onUpdated"
    ></create-or-edit-appointment-component>
  </a-modal>
</template>

<script>
import CreateOrEditAppointmentComponent from "./CreateOrEditAppointmentComponent.vue";
import CreateOrEditCalendarEventComponent from "./CreateOrEditComponent.vue";
import {mapActions, mapGetters} from "vuex";
import store from "../store";

export default {
  name: "CalendarEventCreateOrEditModalComponent",
  components: {
    CreateOrEditAppointmentComponent,
    CreateOrEditCalendarEventComponent
  },
  data() {
    return {
      calendarType: null,
    };
  },
  props: {
    isNewEvent: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: [Number, String],
      required: false,
    },
    attachableKey: {
      type: [String, Number],
      required: false,
    },
    attachableType: {
      type: String,
      required: false,
    },
    attachableDescription: {
      type: String,
      required: false,
    },
    openModal: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      appointment: "$_calendar_event/modalAppointment",
      hasAppointment: "$_calendar_event/hasModalAppointment",
      calendarEvent: "$_calendar_event/modalCalendarEvent",
      hasCalendarEvent: "$_calendar_event/hasModalCalendarEvent",
      onlineAfsprakenEnabled: "onlineAfsprakenEnabled",
      dossierdataCalendarDisabled: "dossierdataCalendarDisabled",
    }),
    getCustomerId() {
      if (typeof this.appointment !== "undefined"
        && this.appointment !== null
        && typeof this.appointment.online_afspraken_customer_id !== "undefined"
        && this.appointment.online_afspraken_customer_id !== null) {
        return this.appointment.customer_id;
      } else {
        return this.customerId;
      }
    },
    title() {
      const title = ((this.calendarEvent && this.calendarEvent.id) || (this.appointment && this.appointment.id))
        ? "Afspraak wijzigen"
        : "Afspraak aanmaken";

      return this.attachableDescription ? title + " voor " + this.attachableDescription : title;
    },
    showModal() {
      return (this.hasCalendarEvent || this.hasAppointment) || this.isNewEvent;
    },
    canChooseCalendar() {
      return this.calendarType === null && !this.isCreatingOrEditingCalendarEvent && !this.isCreatingOrEditingAppointment
        && !this.dossierdataCalendarDisabled && this.onlineAfsprakenEnabled;
    },
    isCreatingOrEditingCalendarEvent() {
      return (this.calendarType === "dossierdata") || (this.hasCalendarEvent && !!this.calendarEvent.id);
    },
    isCreatingOrEditingAppointment() {
      return (this.calendarType === "onlineafspraken") || (this.hasAppointment && !!this.appointment.id);
    },
  },
  methods: {
    ...mapActions({
      hideModal: '$_calendar_event/hideModal',
    }),
    onUpdated() {
      this.$store.commit("$_calendar_event/CALENDAR_EVENT_UPDATED");
      this.$emit("update");
      this.closeModal();
    },
    closeModal() {
      if (!this.dossierdataCalendarDisabled && this.onlineAfsprakenEnabled) {
        this.calendarType = null;
      }
      this.hideModal();
      this.$emit('close');
    }
  },
  created() {
    const STORE_KEY = "$_calendar_event";
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }

    if (!this.dossierdataCalendarDisabled && !this.onlineAfsprakenEnabled) {
      this.calendarType = "dossierdata";
    } else if (this.dossierdataCalendarDisabled && this.onlineAfsprakenEnabled) {
      this.calendarType = "onlineafspraken";
    }
  },
}
</script>

<style scoped>
.full-width {
  width: 100%;
}

.half-width {
  width: 50%;
}
</style>
